type Coord = [number, number];

export const getTopPoint = (coords: Coord[]): Coord => {
  if (coords.length === 0) throw new Error('coords is empty');

  return coords.reduce((mostTopLeft, curr) => {
    if (curr[1] > mostTopLeft[1]) return curr;
    if (curr[1] === mostTopLeft[1] && curr[0] < mostTopLeft[0]) return curr;

    return mostTopLeft;
  }, coords[0]);
};

export const createCustomLabelPosition = (id: string, name: string) => {
  const labelContainer = document.createElement('div');
  labelContainer.classList.add('label-container');
  labelContainer.id = `labelContainer-${id}`;

  const labelName = document.createElement('span');
  labelName.classList.add('fw-bold', 'text-white');
  labelName.id = `labelName-${id}`;
  labelName.innerHTML = name;

  labelContainer.append(labelName);

  return labelContainer;
};
